/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/promise-function-async */
import React from 'react';
import { translateKeyLang } from '../../../../common/src/translate/translateHelper';
import { fetchGet, fetchPost } from '../../store/fetch';
import { appContext } from '../appContext';
import { IconEditButton } from '../common/iconButtons/IconEditButton';
import {
    Content,
    EditPanelButton,
    EditPanelButtons,
    EditPanelCell,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    EditPanelSelect,
    EditPanelSwitch,
    Panel,
    PanelBody,
    PanelBodyHeading,
    PanelButtonLink,
    PanelWithoutForm,
    PopupElement,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';

type ObjectTypeElement = {
    id?: undefined | string;
    name?: undefined | string;
    code?: undefined | string;
    elementGroupName?: undefined | string;
    isStructural?: undefined | boolean;
    replacementIndex?: undefined | string;
};

interface IObjectTypeElementCodesListState extends ObjectTypeElement {
    isSubmitting: boolean;
    isShowPopup: boolean;
    items: ObjectTypeElement[];
}

export class ObjectTypeElementCodes extends React.Component<Record<string, unknown>, IObjectTypeElementCodesListState> {
    constructor(props: Record<string, unknown>) {
        super(props);

        this.state = {
            isSubmitting: false,
            isShowPopup: false,
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.search();
    }

    public override render() {
        return (
            <appContext.Consumer>
                {(appState) => (
                    <>
                        <Topbar>
                            <TopbarLeft>
                                <TopbarCrumbActive title={translateKeyLang(appState.languageCode, 'common.elements')} icon="fa-cogs" />
                            </TopbarLeft>
                            <TopbarRight>
                                <PanelButtonLink
                                    onClick={() => this.copyObjectTypeElementSettings()}
                                    small={true}
                                    text={translateKeyLang(appState.languageCode, 'object.copyObjectTypeElementSettings')}
                                />
                            </TopbarRight>
                        </Topbar>

                        <Content>
                            <Tray>
                                <Panel>
                                    {(this.state.isSubmitting && <Spinner />) || (
                                        <PanelBody noPadding={true}>
                                            <Table>
                                                <TableHead>
                                                    <TableHeadRow light={true}>
                                                        <TableHeader>{translateKeyLang(appState.languageCode, 'common.name')}</TableHeader>
                                                        <TableHeader>Code</TableHeader>
                                                        <TableHeader>
                                                            {translateKeyLang(appState.languageCode, 'object.replacementIndex')}
                                                        </TableHeader>
                                                        <TableHeader>&nbsp;</TableHeader>
                                                    </TableHeadRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.items &&
                                                        this.state.items.map((item) => (
                                                            <TableRow key={item.id}>
                                                                <TableData>{item.name}</TableData>
                                                                <TableData>{item.code}</TableData>
                                                                <TableData>{item.replacementIndex}</TableData>
                                                                <TableData alignRight={true}>
                                                                    <IconEditButton onClick={() => this.handleElementEditClicked(item.id!)} />
                                                                </TableData>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                        </PanelBody>
                                    )}
                                    {this.state.isShowPopup && (
                                        <>
                                            <PopupElement onClick={() => this.setState({ isShowPopup: false })}>
                                                <form method="post" action="/" id="admin-form" onSubmit={() => this.handleSaveUnit()}>
                                                    <PanelWithoutForm>
                                                        <PanelBodyHeading
                                                            text={translateKeyLang(
                                                                appState.languageCode,
                                                                'common.editItem',
                                                                translateKeyLang(appState.languageCode, 'common.element'),
                                                            )}
                                                        >
                                                            <EditPanelSection>
                                                                <EditPanelInput
                                                                    name="name"
                                                                    placeholder={translateKeyLang(appState.languageCode, 'common.name')}
                                                                    value={this.state.name}
                                                                    icon="fa fa-pagelines"
                                                                    handleChange={this.handleChange.bind(this)}
                                                                />
                                                            </EditPanelSection>
                                                            <EditPanelRow>
                                                                <EditPanelCell rowCount={4}>
                                                                    <EditPanelInput
                                                                        name="code"
                                                                        placeholder={translateKeyLang(appState.languageCode, 'common.code')}
                                                                        value={this.state.code}
                                                                        restrictToNumbers={true}
                                                                        handleChange={this.handleChange.bind(this)}
                                                                    />
                                                                </EditPanelCell>
                                                                <EditPanelCell rowCount={4}>
                                                                    <EditPanelInput
                                                                        name="replacementIndex"
                                                                        placeholder={translateKeyLang(
                                                                            appState.languageCode,
                                                                            'object.replacementIndex',
                                                                        )}
                                                                        value={this.state.replacementIndex}
                                                                        restrictToNumbers={true}
                                                                        handleChange={this.handleChange.bind(this)}
                                                                    />
                                                                </EditPanelCell>
                                                            </EditPanelRow>
                                                            <EditPanelRow>
                                                                <EditPanelCell rowCount={6}>
                                                                    <EditPanelSelect
                                                                        name="elementGroupName"
                                                                        placeholder={translateKeyLang(
                                                                            appState.languageCode,
                                                                            'common.selectItem',
                                                                            translateKeyLang(appState.languageCode, 'object.elementGroup'),
                                                                        )}
                                                                        value={this.state.elementGroupName}
                                                                        handleChange={this.handleChange.bind(this)}
                                                                        options={[
                                                                            {
                                                                                value: 'superstructure',
                                                                                text: translateKeyLang(
                                                                                    appState.languageCode,
                                                                                    'elementGroupName.superstructure',
                                                                                ),
                                                                            },
                                                                            {
                                                                                value: 'substructure',
                                                                                text: translateKeyLang(
                                                                                    appState.languageCode,
                                                                                    'elementGroupName.substructure',
                                                                                ),
                                                                            },
                                                                            {
                                                                                value: 'foundation',
                                                                                text: translateKeyLang(
                                                                                    appState.languageCode,
                                                                                    'elementGroupName.foundation',
                                                                                ),
                                                                            },
                                                                        ]}
                                                                    />
                                                                </EditPanelCell>
                                                                <EditPanelCell rowCount={6}>
                                                                    <EditPanelSwitch
                                                                        name="isStructural"
                                                                        placeholder={translateKeyLang(appState.languageCode, 'object.structural')}
                                                                        value={this.state.isStructural}
                                                                        handleChange={this.handleChange.bind(this)}
                                                                    />
                                                                </EditPanelCell>
                                                            </EditPanelRow>
                                                            <EditPanelButtons>
                                                                <EditPanelButton
                                                                    onClick={() => this.setState({ isShowPopup: false })}
                                                                    small={true}
                                                                    text={translateKeyLang(appState.languageCode, 'common.cancel')}
                                                                />
                                                                <EditPanelButton
                                                                    onClick={this.handleSaveUnit.bind(this)}
                                                                    small={true}
                                                                    primary={true}
                                                                    disabled={this.state.isSubmitting}
                                                                    text={translateKeyLang(
                                                                        appState.languageCode,
                                                                        'common.saveItem',
                                                                        translateKeyLang(appState.languageCode, 'common.element'),
                                                                    )}
                                                                />
                                                            </EditPanelButtons>
                                                        </PanelBodyHeading>
                                                    </PanelWithoutForm>
                                                </form>
                                            </PopupElement>
                                        </>
                                    )}
                                </Panel>
                            </Tray>
                        </Content>
                    </>
                )}
            </appContext.Consumer>
        );
    }

    private async copyObjectTypeElementSettings() {
        await this.setState({ isSubmitting: true });
        await fetchPost('/api/objectTypeElementCodes/copy');
        await this.setState({ isSubmitting: false });
    }

    private async search() {
        const url = '/api/objectTypeElementCodes';
        await this.setState({ isSubmitting: true });
        const result = await fetchGet(url);
        await this.setState({ items: result.json, isSubmitting: false });
    }

    private handleChange(value: any, stateKey: string) {
        const newState = {} as any;
        newState[stateKey] = value;
        this.setState(newState);
    }

    private handleElementEditClicked(selectedId: string) {
        for (let i = 0; i < this.state.items.length; i++) {
            const item = this.state.items[i]!;

            if (item.id === selectedId) {
                this.setState({
                    isShowPopup: true,
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    replacementIndex: item.replacementIndex,
                    elementGroupName: item.elementGroupName,
                    isStructural: item.isStructural,
                });
                break;
            }
        }
    }

    private async handleSaveUnit() {
        await this.setState({ isSubmitting: true });
        const data = {
            name: this.state.name,
            code: this.state.code,
            replacementIndex: this.state.replacementIndex,
            elementGroupName: this.state.elementGroupName,
            isStructural: this.state.isStructural,
        } as ObjectTypeElement;

        const url = `/api/objectTypeElementCodes/${this.state.id}`;
        await fetchPost(url, {}, data);
        await this.setState({ isShowPopup: false });
        await this.search();
    }
}
